import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function RefundsPage() {
  return (
    <>
      <SEO
        title="Devoluciones y reembolsos | Imalandia"
        description="Consulta la política de devoluciones, incidencias y reembolsos de Imalandia para productos personalizados y pedidos online."
        canonical={`${SITE_URL}/devoluciones`}
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">DEVOLUCIONES</p>
          <h1>Política de devoluciones y reembolsos</h1>

          <div className="legal-content">
            <p>Última actualización: 30 de julio de 2026.</p>

            <h2>1. Productos no personalizados</h2>

            <p>
              Si la compra corresponde a un producto no personalizado, la
              persona consumidora dispone de 14 días naturales desde su
              recepción para comunicar que desea desistir de la compra, sin
              necesidad de justificar su decisión.
            </p>

            <p>
              Después de comunicar el desistimiento, el producto debe
              devolverse dentro de los 14 días naturales siguientes. Debe
              conservarse y embalarse adecuadamente; el cliente solo responde
              de la disminución de valor causada por una manipulación superior
              a la necesaria para comprobar su naturaleza y características.
            </p>

            <h2>2. Productos personalizados</h2>

            <p>
              El derecho de desistimiento no se aplica a productos
              confeccionados conforme a las especificaciones del cliente o
              claramente personalizados, como artículos producidos con sus
              fotografías, textos, colores u opciones elegidas.
            </p>

            <p>
              Esta excepción no limita los derechos del cliente cuando el
              producto sea defectuoso, llegue dañado o no coincida con el
              pedido.
            </p>

            <h2>3. Productos dañados, defectuosos o incorrectos</h2>

            <p>
              Si existe una incidencia imputable a Imalandia o al transporte,
              debe comunicarse lo antes posible. Se revisará el caso para
              ofrecer, según corresponda, una sustitución, una nueva producción,
              una reparación, una reducción del precio o el reembolso, sin
              costes para el cliente cuando legalmente proceda.
            </p>

            <h2>4. Cómo realizar una solicitud</h2>

            <p>
              Escriba a{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a> e
              indique:
            </p>

            <ul>
              <li>Nombre y número de pedido.</li>
              <li>Producto afectado y motivo de la solicitud.</li>
              <li>
                Fotografías del producto y del embalaje si existe daño, defecto
                o error.
              </li>
            </ul>

            <p>
              También puede contactar en el teléfono{" "}
              <a href="tel:+34646273415">646 273 415</a>. No envíe un paquete
              antes de recibir las instrucciones de devolución.
            </p>

            <h2>5. Gastos de devolución</h2>

            <p>
              En un desistimiento válido por cambio de opinión, el cliente
              asume el coste directo de devolver el producto. Si la devolución
              se debe a un defecto, daño o error imputable a Imalandia, se
              asumirán los costes necesarios de devolución.
            </p>

            <h2>6. Reembolsos</h2>

            <p>
              Cuando proceda el desistimiento, se reembolsarán los importes
              recibidos, incluidos los gastos de entrega estándar, mediante el
              mismo método de pago utilizado en la compra y dentro del plazo
              legal. El reembolso puede retenerse hasta recibir el producto o
              una prueba de su devolución, según qué ocurra primero.
            </p>

            <p>
              En incidencias por productos defectuosos, dañados o incorrectos,
              el reembolso o la solución acordada se tramitará después de
              revisar la información aportada y, cuando sea necesario, el
              producto.
            </p>

            <h2>7. Contacto</h2>

            <p>
              Correo:{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a>
              <br />
              Teléfono: <a href="tel:+34646273415">646 273 415</a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
